module.exports = __webpack_public_path__ + "static/media/back-new-7.af0a5159.jpg";